/**
 * Baked dictionary for human-readable reference slugs (`adjective-noun-N`).
 * Curated to be calm and forgiving — NO scary words (fatal/dead/broken/crashed)
 * and NO offensive words. Two ~80-word lists × 99 ≈ 630k combinations, enough
 * for low-collision error references (the full `agf_` UUID is the real id; the
 * slug is a copy-paste convenience). Lists can grow toward the ~25M target.
 */

export const ADJECTIVES: readonly string[] = [
  'amber',
  'azure',
  'brave',
  'bright',
  'breezy',
  'bubbly',
  'calm',
  'cheery',
  'clever',
  'cozy',
  'crisp',
  'dapper',
  'daring',
  'dewy',
  'eager',
  'easy',
  'fair',
  'fancy',
  'fleet',
  'fluffy',
  'fond',
  'fresh',
  'gentle',
  'glad',
  'gleeful',
  'golden',
  'grand',
  'happy',
  'hardy',
  'hearty',
  'honest',
  'humble',
  'jaunty',
  'jolly',
  'keen',
  'kind',
  'lively',
  'lucky',
  'lush',
  'mellow',
  'merry',
  'mighty',
  'mild',
  'minty',
  'modest',
  'neat',
  'nimble',
  'noble',
  'peppy',
  'perky',
  'plucky',
  'polite',
  'proud',
  'quaint',
  'quick',
  'quiet',
  'ready',
  'regal',
  'ripe',
  'rosy',
  'royal',
  'rustic',
  'sandy',
  'shiny',
  'silky',
  'simple',
  'sleek',
  'smiling',
  'snappy',
  'snowy',
  'soft',
  'spry',
  'sturdy',
  'sunny',
  'swift',
  'tidy',
  'trusty',
  'upbeat',
  'vivid',
  'warm',
  'wise',
  'witty',
  'zesty',
];

export const NOUNS: readonly string[] = [
  'acorn',
  'badger',
  'beacon',
  'bramble',
  'brook',
  'cabin',
  'canyon',
  'cedar',
  'cherry',
  'clover',
  'comet',
  'cottage',
  'daisy',
  'dune',
  'ember',
  'falcon',
  'fern',
  'garden',
  'ginger',
  'harbor',
  'harvest',
  'hazel',
  'heron',
  'island',
  'jasmine',
  'juniper',
  'kettle',
  'lagoon',
  'lantern',
  'lark',
  'lemon',
  'lily',
  'lotus',
  'mango',
  'maple',
  'marble',
  'meadow',
  'mesa',
  'mitten',
  'moss',
  'nectar',
  'nutmeg',
  'oak',
  'olive',
  'opal',
  'orchard',
  'otter',
  'pansy',
  'parsley',
  'peach',
  'pebble',
  'pine',
  'planet',
  'pond',
  'poppy',
  'prairie',
  'quail',
  'quilt',
  'raccoon',
  'reef',
  'river',
  'robin',
  'sage',
  'sail',
  'salmon',
  'sequoia',
  'sparrow',
  'spruce',
  'squirrel',
  'sunset',
  'teapot',
  'thistle',
  'timber',
  'tulip',
  'turtle',
  'valley',
  'vine',
  'walnut',
  'willow',
  'wren',
];
